import React, { memo, useRef } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import useDocumentTitle from 'hooks/useDocumentTitle';

import {
  ContentLayoutPropTypes,
  defaultContentOptions,
  defaultHeaderOptions,
  defaultSidebarOptions,
} from './ContentLayout.constants';
import {
  getContentStyles,
  getHeaderStyles,
  getMainContainerStyles,
  wrapperStyles,
} from './ContentLayout.styles';
import Sidebar from './Sidebar';

const ContentLayout = ({
  content,
  contentOptions = defaultContentOptions,
  header,
  headerOptions = defaultHeaderOptions,
  helmetProps,
  sidebar,
  sidebarOptions = defaultSidebarOptions,
  children,
}) => {
  const wrapperRef = useRef(null);

  useDocumentTitle(helmetProps?.title, {
    defaultTitle: helmetProps?.defaultTitle,
    titleTemplate: helmetProps?.titleTemplate,
  });

  return (
    <Box ref={wrapperRef} sx={wrapperStyles}>
      {sidebar && (
        <Sidebar options={sidebarOptions} wrapperRef={wrapperRef}>
          {sidebar}
        </Sidebar>
      )}

      <Box
        component="main"
        sx={getMainContainerStyles({
          isScrollableContent: contentOptions?.isScrollable,
        })}
      >
        {header && (
          <Box
            className={clsx('page-header', headerOptions?.className)}
            component="header"
            sx={getHeaderStyles(headerOptions)}
            {...headerOptions?.props}
          >
            {header}
          </Box>
        )}

        {(children ?? content) && (
          <Box
            className={clsx('page-content', contentOptions?.className)}
            sx={getContentStyles(contentOptions)}
            {...contentOptions?.props}
          >
            {children ?? content}
          </Box>
        )}
      </Box>
    </Box>
  );
};

ContentLayout.propTypes = ContentLayoutPropTypes;

export default memo(ContentLayout);
